export default "__VITE_ASSET__DjG5$sZy__"